'use client';
import { useMemo, useRef, useEffect } from 'react';
import { useExperiment } from './useExperiment';

export const useResolvedExperiment = (data, transformBlocks) => {
  const testData = Array.isArray(data) ? data[0] : data;
  const testName = testData?.testName || testData?.test_name || null;
  const { value = 'control' } = useExperiment(testName);

  const transformRef = useRef(transformBlocks);
  useEffect(() => {
    transformRef.current = transformBlocks;
  }, [transformBlocks]);

  return useMemo(() => {
    const isAbTest =
      !!testData?.variants &&
      (testData?.component === 'flagship_ab_test' || !!testName);
    if (!testData || !isAbTest) return data;

    const variant = testData.variants.find(v => v.variant_name === value);

    if (transformRef.current) {
      return transformRef.current(variant?.blocks, data);
    }

    return data;
  }, [data, value, testData, testName]);
};
